
import { generateRootObjectSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { PlaylistParticleSpec } from "components/cards/particles/YinzCam/Media/Playlist";

export const specification = new BaseAtomSpec("Playlist Atom", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  playlist: PlaylistParticleSpec.generateSchema("Playlist", "The playlist."),
}));